import { createStore } from 'redux';
import { createReducers } from './reducers';

export const initializeStore = (initialState = {}) => {
	const store = createStore(createReducers(), initialState);
	// Add a dictionary to keep track of the registered async reducers
	store.asyncReducers = {};

	// Create an inject reducer function
	// This function adds the async reducer, and creates a new combined reducer
	store.injectReducer = (key, asyncReducer) => {
		store.asyncReducers[key] = asyncReducer;
		store.replaceReducer(createReducers(store.asyncReducers));
	};

	// Return the modified store
	return store;
};
